/* ============================================================================
   Château Acid — theme.js
   - Random hero image on load (1 of 3, by IDs hero-img-0/1/2)
   - Nav hide on scroll (homepage only)
   - Age gate modal (Shop links require confirmation, persisted in sessionStorage)
   - Club Acid scroll-near-bottom popup (homepage only, once per session)
   ========================================================================== */

(function () {
  'use strict';

  function $(id) { return document.getElementById(id); }
  function $q(sel) { return document.querySelector(sel); }
  function $qa(sel) { return document.querySelectorAll(sel); }

  /* ------------------------------------------------------------ Random hero */
  (function randomHero() {
    var heroes = $qa('[id^="hero-img-"]');
    if (!heroes.length) return;
    var pick = Math.floor(Math.random() * heroes.length);
    heroes.forEach(function (el, i) {
      el.style.display = (i === pick) ? 'block' : 'none';
    });
  })();

  /* ----------------------------------------------------- Nav hide on scroll */
  (function navHide() {
    var nav = $q('.ca-nav');
    if (!nav) return;
    var isHome = document.body.classList.contains('is-home');
    if (!isHome) return;
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY;
      if (scrollY > window.innerHeight * 0.15) {
        nav.style.transform = 'translateY(-100%)';
        nav.style.opacity = '0';
        nav.style.pointerEvents = 'none';
      } else {
        nav.style.transform = 'translateY(0)';
        nav.style.opacity = '1';
        nav.style.pointerEvents = 'auto';
      }
    }, { passive: true });
  })();

  /* ---------------------------------------------------------- Age gate ---- */
  var AGE_KEY = 'ca_age_confirmed';
  function ageConfirmed() {
    try { return sessionStorage.getItem(AGE_KEY) === '1'; } catch (_) { return false; }
  }
  function setAgeConfirmed() {
    try { sessionStorage.setItem(AGE_KEY, '1'); } catch (_) {}
  }
  function showAgeGate(callback) {
    if (ageConfirmed()) { if (callback) callback(); return; }
    var gate = $('age-gate');
    if (!gate) { if (callback) callback(); return; }
    gate.classList.add('visible');
    gate._callback = callback;
  }
  function confirmAge() {
    setAgeConfirmed();
    var gate = $('age-gate');
    if (gate) {
      gate.classList.remove('visible');
      var cb = gate._callback;
      gate._callback = null;
      if (cb) cb();
    }
  }
  window.showAgeGate  = showAgeGate;
  window.confirmAge   = confirmAge;

  var ageCheckbox = $('age-confirm');
  var ageEnterBtn = $('age-gate-enter');
  if (ageCheckbox && ageEnterBtn) {
    ageCheckbox.addEventListener('change', function () {
      ageEnterBtn.disabled = !this.checked;
    });
    ageEnterBtn.addEventListener('click', confirmAge);
  }

  $qa('a[data-age-gate="true"]').forEach(function (a) {
    a.addEventListener('click', function (evt) {
      if (ageConfirmed()) return;
      evt.preventDefault();
      var href = a.getAttribute('href');
      showAgeGate(function () { window.location.href = href; });
    });
  });

  var isShopPage = window.location.pathname === '/pages/shop' ||
                   document.body.classList.contains('template-collection') ||
                   document.body.classList.contains('template-product');
  if (isShopPage) showAgeGate();

  /* ---------------------------------------------------- Club Acid popup --
     Rules:
       - Only ever appears on the homepage
       - Triggers when the user scrolls within 100px of the bottom of the page
       - Shows at most ONCE per browser session (sessionStorage flag set the
         first time it appears — whether or not the user dismisses it). */
  var CLUB_KEY = 'ca_club_shown';

  function clubAlreadyShown() {
    try { return sessionStorage.getItem(CLUB_KEY) === '1'; } catch (_) { return false; }
  }
  function markClubShown() {
    try { sessionStorage.setItem(CLUB_KEY, '1'); } catch (_) {}
  }
  function dismissClubPopup() {
    markClubShown();
    var popup = $('club-popup');
    if (popup) popup.classList.add('dismissed');
  }
  window.dismissClubPopup = dismissClubPopup;

  var clubClose = document.querySelector('#club-popup .club-popup-close');
  if (clubClose) clubClose.addEventListener('click', dismissClubPopup);

  if (clubAlreadyShown() || !document.body.classList.contains('is-home')) {
    var popup = $('club-popup');
    if (popup) popup.classList.add('dismissed');
  } else {
    window.addEventListener('scroll', function () {
      if (clubAlreadyShown()) return;
      if (window.scrollY + window.innerHeight >= document.body.scrollHeight - 100) {
        var popup = $('club-popup');
        if (popup) popup.classList.add('visible');
        markClubShown();
      }
    }, { passive: true });
  }

  /* ------------------------------------------------------- Theme editor -- */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      /* no-op */
    });
  }
})();